export default {
  get(name: string) {
    return new URLSearchParams(window.location.search).get(name)
  },
  set(name: string, value: string) {
    const url = new URL(window.location.href)

    url.searchParams.set(name, value)

    window.history.replaceState(window.history.state, '', url)
  },
}
